import React from 'react'
import Footer from '../components/Footer'
import Navbar from "../components/Navbar"
import "../styles/policy.css"
import Seo from "../components/Seo";

const RefundPolicy = () => {
  return (
    <>
      <Seo path="/refund-policy" />
      <Navbar />
      <section>
        <div className="term-container">
          <h1>Refund &amp; Cancellation Policy</h1>
          <article>
            <p>
              Cloudare Technologies Private Limited provides professional services — ERP
              implementation and support, e-invoicing and compliance integration, software
              development, and IT staffing. This policy explains how refunds and cancellations work
              for those services. As we do not sell physical goods, there are no shipping, returns
              or exchanges.
            </p>

            <h3>Engagement-based terms</h3>
            <p>
              Most engagements are governed by a signed proposal, statement of work (SOW) or service
              agreement that sets out fees, milestones, payment schedule and cancellation terms. Where
              such an agreement exists, its refund and cancellation provisions apply. This page
              applies where no separate agreement specifies otherwise.
            </p>

            <h3>Project and consulting services</h3>
            <p>
              Fees for project and consulting work are typically tied to milestones or time already
              delivered. Amounts corresponding to work completed, accepted or in progress are
              non-refundable. If you wish to cancel an ongoing engagement, please notify us in writing
              at <b>hello@cloudare.in</b>; we will invoice for work performed up to the cancellation
              date and release any genuinely unused, prepaid balance where applicable.
            </p>

            <h3>Subscriptions, retainers and AMC</h3>
            <p>
              Recurring services such as managed services, retainers or annual maintenance contracts
              (AMC) may be cancelled with the notice period stated in your agreement. Fees for the
              current, already-commenced billing period are generally non-refundable, and cancellation
              takes effect at the end of that period unless agreed otherwise.
            </p>

            <h3>Third-party licences and fees</h3>
            <p>
              Software licences, government or portal fees, and charges from third-party providers
              (for example, ERP vendors or e-invoicing service providers) are governed by the terms of
              the respective provider and are non-refundable through Cloudare once procured on your
              behalf.
            </p>

            <h3>How to request a refund or raise a concern</h3>
            <p>
              To request a refund, discuss a cancellation, or raise any billing concern, email us at
              <b> hello@cloudare.in</b> with your company name and engagement reference. We aim to
              acknowledge requests promptly and to resolve them fairly and in good faith. Approved
              refunds are processed to the original payment method within a reasonable period.
            </p>

            <h3>Changes to this policy</h3>
            <p>
              We may update this Refund &amp; Cancellation Policy from time to time. Changes take
              effect when posted on this page.
            </p>
          </article>
        </div>
      </section>
      <Footer />
    </>
  )
}
export default RefundPolicy
